<template>
  <v-container
    v-if="cashRegister.openedReport"
    fluid
    grid-list-md
  >
    <v-row wrap>
      <v-col cols="3">
        <info-card :title="$t('Cash Management')">
          <p>{{ $t('Throughout the day you may want to add or remove cash from the cash drawer.') }}
            {{ $t('Add or remove cash by clicking on the button right below.') }}</p>

          <h4 class="mb-1">{{ $t('Cash-In') }}</h4>
          <p>{{ $t('This allows you to track any additional money you put into your cash drawer. This is used to increase your float amount during the day if required.') }}</p>

          <h4 class="mb-1">{{ $t('Cash-Out') }}</h4>
          <p>{{ $t('You can use this option to track any cash you remove from your cash drawer. Cash out can be used to track actions such as safe drops, where you may need to remove cash from your drawer during the day for safekeeping.') }}</p>

          <h4 class="mb-1">{{ $t('Close {0}', [$t('Cash Register')]) }}</h4>
          <p class="mb-0">{{ $t('Register closures are a basic part of retail that allow you to physically check your cash and credit totals against their recorded totals.') }}</p>

          <v-divider class="mt-4 mb-1" />

          <v-btn
            :to="{ name: 'CashRegisterReportsIndex' }"
            block
            class="ma-0 mt-4"
            color="primary"
            dark
            depressed
          >{{ $t('Register Closures') }}</v-btn>
        </info-card>
      </v-col>
      <v-col cols="9">
        <cash-movements-table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import CashMovementsTable from '@/components/cash-movements/CashMovementsTable'
import InfoCard from '@/components/InfoCard'
import { mapGetters } from 'vuex'
export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    CashMovementsTable,
    InfoCard
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Cash Management')
  }),

  computed: {
    ...mapGetters(['cashRegister'])
  },

  watch: {
    cashRegister: {
      immediate: true,
      handler (cashRegister) {
        this.checkRedirect()
      }
    }
  },

  methods: {
    checkRedirect () {
      if (_.size(this.cashRegister) && !this.cashRegister.openedReport) {
        this.$router.push({ name: 'CashRegistersOpenClose' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cash-registers/CashManagement.vue